export default {
  // Login page
  login: "Войти",
  logout: "Выйти",
  forgetPassword: "Забыли пароль?",
  toRegister: "Зарегистрироваться",
  UIN: "ИИН",
  step: "ШАГ",
  step1: "Введите ваш ИИН",
  step2:
    "Введите пароль, созданный вами при регистрации. Если вы не помните пароль, выберите опцию “Забыли пароль?”",
  step3: "Нажмите на кнопку “Войти”",
  "Неверный логин и/или пароль!": "Неверный логин и/или пароль!",
  registration: "Регистрация",
  BIN: "БИН",
  phoneNumber: "Номер телефона",
  back: "Назад",
  next: "Далее",
  requiredField: "Поле обязательно для заполнения",
  "A network error (such as timeout, interrupted connenction or unreachable host) has occured":
    "Произошла ошибка сети (например, тайм-аут, прерванное соединение или недоступный хост)",
  enterEmail: "Введите Email",
  enterValidEmail: "Введите корректный email",
  enterUINorBIN: "Введите ИИН/БИН",
  chooseTaxOrgan: "Выберите налоговый орган",
  UINLength: "ИИН/БИН состоит из 12 символов",
  serieLength: "Серия должна состоять из 5 знаков",
  VATLength: "Номер НДС должен состоять из 7 знаков",
  enterPhone: "Введите телефон",
  chooseTaxType: "Выберите тип налога",
  onlyLatin: "Только символы английского алфавита ",
  capitalizeRequired: "Не менее одной заглавной буквы",
  numberRequired: "Не менее одной цифры",
  lengthSymbols: "не менее 8 символов",
  repeatPassword: "Повторите пароль",
  passwordDontMatch: "Пароли на совпадают",
  // Profile page
  profilePage: "Личная страница",
  analyticsPage: "Аналитика",
  supplyPage: "Запасы",
  discountPage: "Акции",
  purchasesPage: "Закупки",
  salesPage: "Продажи",
  salesReportPage: "Проданные товары",
  selectStorePage: "Магазины",
  cashboxPage: "Кассы",
  employeesPage: "Сотрудники",
  inventoriesPage: "Инвентаризация",
  fullname: "ФИО",
  legalAddress: "Юридический адрес",
  VAT: "НДС",
  taxOrgan: "Налоговый орган",
  taxType: "Тип налога",
  store: "магазин",
  stores: "Магазин(ы)",
  storeName: "Название магазина",
  storeAddress: "Адресс магазина",
  storagePage: "Категории",
  // AnalyticsPage
  dailyStatistic: "Статистика за сутки",
  today: "сегодня",
  yesterday: "вчера",
  sales: "Продажи",
  // SelectStorPage
  chooseStore: "Выберите магазин",
  add: "Добавить",
  Reports: "Отчеты",
  addProduct: "Добавить продукт",
  "Add new product": "Добавить новый продукт",
  select: "Выбрать",
  change: "Изменить",
  delete: "Удалить",
  cancel: "Отменить",
  create: "Создать",
  save: "Сохранить",
  profit: "Прибыль",
  averageCheck: "ср. чек",
  order1: "заказов",
  order2: "заказ",
  order3: "заказа",
  client1: "клиентов",
  client2: "клиент",
  client3: "клиента",
  total: "Итого",
  numDays: "дней",
  month: "месяц",
  numMonth: "месяца",
  other: "Другое",
  allSupplies: "Всего",
  barcode: "Штрих-код",
  supplyTitle: "Наименование",
  priceSale: "Цена\nпродажи, тг",
  priceSale2: "Цена продажи",
  stock: "Остаток",
  stockBalance: "Остаток\nна складе",
  searchWithBarcodeName: "Поиск по штрих-коду или наименованию",
  searchWithName: "Поиск по наименованию товара",
  pageWord: "стр.",
  unitsMeasuring: "Ед.изм.",
  unitsMeasuringStorage: "Ед.изм. на складе",
  discount: "Скидка",
  datePurchase: "Дата закупки",
  purchasesInfo: "Информация о закупке",
  purchasePrice: " Цена\nзакупки, тг",
  title: "Название",
  amountProduct: "Кол-во товаров",
  description: "Описание",
  from: "От",
  to: "До",
  discountPercent: "Скидка, %",
  addDiscount: "Добавить акцию",
  link: "ссылка",
  forOperators: "для операторов",
  employe: "Сотрудник",
  totalPrice: "Общая\nстоимость, тг",
  note: "Примечание ",
  purchasesSum: "Закуплено\nвсего",
  cashboxId: "Номер кассы",
  saleId: "Номер продажи",
  dateSale: "Дата продажи",
  quantity: "Количество",
  price: "Цена, тг",
  fiscalize: "фискализировать",
  nameCashbox: "Имя кассы",
  idCashbox: "ID кассы",
  titleStore: "Название магазина",
  addressStore: "Адрес магазина",
  state: "Состояние",
  fiscal: "Фискализация",
  cashboxInfo: "Информация о кассе",
  shiftInfo: "Информация о смене",
  idNumber: "Идентификационный номер",
  factoryNumber: "Заводской номер",
  serialNumber: "Серийный номер",
  cashboxDescription: "Описание кассы",
  registrationNumber: "Регистрационный номер",
  dateRegister: "Дата регистрации",
  wayEnterDiscount: "Способ ввода скидки",
  defaultIndustry: "Вид отрасли по умолчанию",
  purchaseMode: "Режим &quot;Покупка&quot;",
  markup: "Наценка",
  serviceCenter: "Обслуживающее ЦТО",
  activationPackage: "Активационный пакет",
  modeOperation: "Режим работы",
  CRF: "ОФД",
  confirmCode: "Код подтверждения",
  switchedOn: "Включен",
  switchedff: "Выключен",
  disconnected: "Отключена",
  connected: "Включена",
  isAbsent: "Отсутствует",
  shiftNumber: "Номер смены",
  shiftOpening: "Открытие смены",
  cashOnHand: "Наличных в кассе",
  numberOfSales: "Количество продаж",
  returnSales: "Возвратов продаж",
  cashSales: "Продаж наличными",
  cardSale: "Продаж банковской картой",
  numberOfPurchases: "Количество покупок",
  numberOfRefunds: "Количество возвратов покупок",
  deposit: "Внесение",
  withdrawal: "Изъятие",
  sum: "Сумма",
  numberOfDocuments: "Количество документов",
  shiftClosing: "Закрытие смены",
  roles: "Права",
  lastname: "Фамилия",
  middlename: "Отчество",
  firstname: "Имя",
  sendPassword: "Отправить пароль",
  startInventory: "Начать инвентаризацию",
  pastInventory: "Прошлые инвентаризации",
  dateStart: "Дата начала",
  dateEnd: "Дата окончания ",
  show: "Показывать",
  edit: "Редактировать",
  toComplete: "Завершить",
  discountToProduct: "Акция на товар",
  titleProduct: "Название товара",
  saveChanges: "Сохранить изменения",
  createNewDiscount: "Создание новой акции",
  titleDiscount: "Название акции",
  product: "товар",
  find: "Найти",
  enterProductName: "Введите название товара",
  addToDiscount: "Добавить в акцию",
  createDiscount: "Создать акцию",
  createPromotionalItem: "Создание акционного товара",
  confirmDelete: "Подтвердить удаление",
  fiscalized: "Фискализирована",
  notFiscalized: "Не фискализирована",
  AddingToCategory: "Добавление в категорию",
  AddToCategory: "Добавить в категорию",
  yes: "Да",
  no: "Нет",
  enterStoreName: "Введите название магазина",
  selectStorage: "Выберите магазин",
  registerIdCashbox: "Регистрационный номер кассы",
  dataChange: "Изменение данных",
  notFoundPage: "Страница не найдена",
  "In this section you can work with your cash registers, namely":
    "В данном разделе вы можете работать с вашими кассами, а именно:",
  "Create new cash desks": "Создавать новые кассы",
  "Delete existing cash desks": "Удалять существующие кассы",
  "Edit Title": "Редактировать название",
  "Turn on / off cash desks": "Включать/выключать кассы",
  "Fiscalize cash registers": "Фискализировать кассы",
  "In this section you can create, modify and delete stocks of your stores":
    "В данном разделе вы можете создавать, изменять и удалять акции ваших магазинов",
  "In this section you can": "В данном разделе вы можете:",
  "Add new employees to stores": "Добавлять новых сотрудников в магазины",
  "Remove employees from stores": "Удалять сотрудников из магазинов",
  "Edit employee access levels": "Редактировать уровни доступа сотрудников",
  "Please note that to add an employee, his / her IIN and cell phone number are required":
    "Обратите внимание, для добавления сотрудника необходимы его/её ИИН и сотовый номер телефона",
  "Conduct a new inventory": "Провести новую инвентаризацию",
  "View details of previous inventories":
    "Просмотреть подробности предыдущих инвентаризаций",
  "Link copied": "Ссылка скопирована",
  "In the menu of a specific inventory you can":
    "В меню конкретной инвентаризации вы можете:",
  "Complete inventory at the end of the inventory":
    "Завершить инвентаризацию по ее окончанию",
  "Delete inventory": "Удалить инвентаризацию",
  "Export inventory": "Экспортировать инвентаризацию",
  "In this section you can see detailed information about the owner of this Smartkassa account":
    "В данном разделе вы можете увидеть подробную информацию о владельце этого аккаунта Smartkassa.",
  Signature: "Подпись:",
  "Goods from the purchase": "Товары из закупки",
  "In this section you can observe the information on purchases, namely":
    "В данном разделе вы можете получить информацию по закупкам, а именно:",
  "Date of purchase": "Дату проведения закупки",
  "The cashier who procured": "Кассира, проводившего закупку",
  "Total cost": "Общую стоимость",
  "Various purchase notes": "Различные примечания к закупке",
  "Click on the purchase you are interested in for more information":
    "Нажмите на интересующую вас закупку для получения подробной информации",
  "Password sent to the specified number":
    "Пароль отправлен на указанный номер!",
  "Incorrect code entered": "Введен неверный код",
  "Enter code": "Введите код",
  "Password recovery": "Восстановление пароля",
  "Login/IIN": "Логин/ИИН",
  "Enter the code sent to your number": "Введите код отправленный Вам на номер",
  "Confirm password": "Подтвердить пароль",
  "Enter the correct code": "Введите корректный код",
  "In this section you can observe information on sales, namely":
    "В данном разделе вы можете получить информацию по продажам, а  именно:",
  "Date of sale": "Дату проведения продажи",
  "The cashier who conducted the sale": "Кассира, проводившего продажу",
  "Various sales notes": "Различные примечания к продаже",
  "Click on the sale you are interested in for more information":
    "Нажмите на интересующую вас продажу для получения подробной информации",
  "In this section you can observe detailed information about each sold product for a certain period, including":
    " В данном разделе вы можете получить подробную информацию о каждом проданном товаре за определенный период, в том числе:",
  "Unit of measure": "Единица измерения товара",
  "Total cost of goods": "Общая стоимость товара",
  "Unit of measure in stock": "Единица измерения на складе",
  "Enter the correct password code": "Введите корректный код-пароль",
  "Choose a store, information about which you want to receive":
    "Выбирать магазин, информацию о котором вы хотите получить",
  "Create new stores": "Создавать новые магазины",
  "Edit store names and addresses": "Редактировать названия и адреса магазинов",
  "Delete existing stores": "Удалять существующие магазины",
  "Shop Creation": "Создание магазина",
  // Set the name and address of the store. Please note that you specify the name of a specific point of sale (later you can change the name). The address must match the address issued during registration with the tax authority
  "Select Storage Shop creation step 1 info":
    "Задайте название и адрес магазина. Обратите внимание, что вы задаете название конкретной точки продажи (впоследствии вы сможете изменить название). Адрес должен совпадать с адресом, выданным при регистрации в налоговом органе",
  "The address must match the address issued during registration with the tax authority":
    "Адрес должен совпадать с адресом, выданным при регистрации в налоговом органе",
  "Cash desk creation": "Создание кассы",
  "Creation of the first cash desk Name the cashier and select the store in which it is located":
    "Создание первой кассы. Задайте название кассы и выберите магазин, в котором она находится",
  "Cashbox name": "Название кассы",
  "Fiscalize cashbox": "Фискализация кассы",
  "Please note that if you have a physical cashier, you can Smartkassa in non-fiscal mode by printing checks through your physical cashier":
    "Обратите внимание, что если у вас физическая касса - вы можете Smartkassa в нефискальном режиме, печатая чеки через вашу физическую кассу.",
  "Prerequisites for Fiscalization": "Необходимые условия для фискализации:",
  "cash register must be registered with the tax authority":
    "касса должна быть зарегистрирована в налоговом органе",
  "account on the Webkassa service (paid separately on the website wwwwebkassakz)":
    "аккаунт на сервисе Webkassa (оплачивается отдельно на сайте www.webkassa.kz)",
  "CRF account (paid separately on the website wwwoofdkz)":
    "аккаунт ОФД (оплачивается отдельно на сайте www.oofd.kz)",
  "To Fiscalize": "Фискализировать",
  skip: "Пропустить",
  "Create employee": "Создание сотрудника",
  "To register an employee, you need:":
    "Для регистрации сотрудника необходимы:",
  "IIN employee and": "ИИН сотрудника и",
  "employee's cell phone number This number will receive the employee password to log into the Smartkassa system":
    "сотовый номер телефона сотрудника. На этот номер поступит пароль сотрудника для входа в систему  Smartkassa.",
  "Submit Code": "Отправить код",
  "Password was sent to the specified number":
    "Пароль был отправлен на указанный номер",
  "In this section you can observe detailed information for each of the goods you have, namely":
    "В данном разделе вы можете получить подробную информацию по каждому из имеющихся у вас товаров, а именно:",
  "Purchase price": "Цена закупки",
  "The total cost of the sale of goods": "Общая стоимость продажи товара",
  "Setted discount": "Установленная скидка",
  "Click on a product for more information":
    "Нажмите на товар для получения дополнительной информации",
  "Once you have added the stocks, add the good ones and click on the 'Add to stocks' item below":
    "Для добавления товаров в акцию, выберите нужные товары и нажмите  “Добавить в акцию”, после чего выберите нужную акцию или создайте новую",
  "Data not found": "Данные не найдены!",
  "In storage": "На складе:",
  new1: "Новое:",
  new2: "Новая:",
  new3: "Новый:",
  unitsMeasuringFull: "Единица измерения:",
  purchasePrice2: "Цена закупа: ",
  addUnitsMeasuring: "Добавить единицу измерения",
  select2: "Выберите",
  selectUnitsMeasuring: "Выберите единицу измерения",
  purchased: "Закуплено",
  value: "Значение",
  clear: "Очистить",
  apply: "Применить",
  "To add a filter, press Enter, then Apply":
    "Для добавления фильтра, нажмите Enter, затем Применить",
  "In this section you can observe information on purchases, sales and profits of a particular store or product":
    "В данном разделе вы можете получить информацию о закупках, продажах и прибыли определенного магазина или товара.",
  titelInventory: "Название инвентаризации",
  redirectInventory: "Страница инвентаризации",
  payAll: "оплатить все",
  payAFew: "оплатить несколько",
  pay: "оплатить",
  fyscalized: "фискализирован",
  nonFyscalized: "не фискализирован",
  extendsFor: "продлена до",
  duration: "длительность",
  months: "месяца",
  all: "все",
  drop: "убрать",
  activeBy: "активна до",
  fyscalization: "фискализация",
  remainderOnStorage: "Остаток на складе",
  remainder: "Остаток",
  purchasePrice1: "Цена покупки",
  purchaseprice: "Цена покупки",
  salePrice1: "Цена продажи",
  saleprice: "Цена продажи",
  addPhotoes: "Добавить фотографии",
  uploadPhotoes: "Загрузить фотографии",
  "Export to Excel": "Экспорт в Excel",
  "New inventory": "Новая инвентаризация",
  years: "года",
  weeks: "недели",
  "select week": "выбрать неделю",
  "select dates": "выберите даты",
  year: "год",
  checkNum: "Номер чека",
  AddChartToCompare: "добавить график для сравнения",
  AddComparableChart: "добавить сравнительный график",
  "Comparative graph for time periods of different lengths":
    "Сравнительный график для временных отрезков разных длин",
  "Comparative Line Chart": "Сравнительный график линейных графиков",
  January: "Янаврь",
  February: "Февраль",
  March: "Март",
  April: "Апрель",
  May: "Май",
  June: "Июнь",
  July: "Июль",
  August: "Август",
  September: "Сентябрь",
  October: "Oктябрь",
  November: "Ноябрь",
  December: "Декабрь",
  Monday: "Понедельник",
  Tuesday: "Вторник",
  Wednesday: "Среда",
  Thursday: "Четверг",
  Friday: "Пятница",
  Saturday: "Суббота",
  Sunday: "Воскресение",
  "Trade negative": "Торговать в минус",
  search: "Поиск",
  Found: "Найдено",
  "of goods": "продуктов",
  "Select a category": "Выберите категорию",
  showCategorySidebar: "показать",
  hideCategorySidebar: "скрыть",
  Menu: "Меню",
  paymentPage: "Страница оплаты",
  name: "имя",
  nds: "НДС",
  accountInormation: "Данные об учётной записи",
  companyInformation: "Данные о компании",
  dataOnAvailableStores: "Данные о доступных магазинах",
  organization: "Организация",
  Login: "Логин",
  password: "пароль",
  "Old password": "Введите старый пароль",
  "New password": "Введите новый пароль",
  "Repeat new password": "Повторите новый пароль",
  "Change password": "Изменить пароль",
  "Data loading": "Загрузка данных",
  Inventory: "Инвентаризация",
}
